import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb51c50e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=cb51c50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb51c50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb51c50e')) {
      api.createRecord('cb51c50e', component.options)
    } else {
      api.reload('cb51c50e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cb51c50e&scoped=true&", function () {
      api.rerender('cb51c50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overdue/index.vue"
export default component.exports